import { schema } from 'normalizr';

export const categoryTRSchema = new schema.Entity('categoriesTR', {}, { idAttribute: 'CategoryTRId' });
export const categoryTRListSchema = [categoryTRSchema];
